import { useState, useEffect } from 'react';
import { gmLatLng } from '../util/googleMaps';

const getClosestDistance = (geolocation, originStr) => {
    const windowDefined = typeof window !== undefined;

    if (!windowDefined) return null;

    const { maps } = window.google;

    const [lat, lng] = originStr.split(',');

    if (!lat || !lng || !maps || !maps.geometry || !maps.geometry.spherical) return null;

    const { computeDistanceBetween } = maps.geometry.spherical;

    const listingLatLng = gmLatLng(geolocation.lat, geolocation.lng);
    const originLatLng = gmLatLng(lat, lng);

    if (!listingLatLng || !originLatLng) return 0;

    return (computeDistanceBetween(originLatLng, listingLatLng) / 1000).toFixed(1);
};

/**
 * Add distanceFromSelectedPlace prop to listings
 *
 * @param {} listings sdk listing
 * @param {} originStr lat,lng string
 * @returns Array<listings>
 */
export const useListingsWithDistance = (listings, originStr, applySorting = true) => {
    const [listingsWithDistance, setListingsWithDistance] = useState([]);
    const isListingsArray = Boolean(Array.isArray(listings) && listings.length > 0);
    const listingsIds = isListingsArray ? listings.map(({ id: { uuid } }) => uuid).join(',') : '';

    useEffect(() => {
        if (!originStr || !listingsIds) {
            return setListingsWithDistance(listings);
        }

        const insertDistanceInfo = l =>
            Boolean(l?.attributes?.geolocation)
                ? {
                      ...l,
                      distanceFromSelectedPlace: getClosestDistance(
                          l.attributes.geolocation,
                          originStr
                      ),
                  }
                : { ...l, distanceFromSelectedPlace: 0 };

        const listingsWithDistance = listings.map(insertDistanceInfo);

        setListingsWithDistance(
            applySorting
                ? listingsWithDistance.sort(
                      (a, b) => a.distanceFromSelectedPlace - b.distanceFromSelectedPlace
                  )
                : listingsWithDistance
        );
    }, [listingsIds, originStr]);

    return listingsWithDistance;
};
